import { Injectable } from '@angular/core';
import { ActivityShareRequest } from '@jms/model';
import { ActivityService } from '@workbuddy/ui/modules/activities';

@Injectable()
export class ContractorActivityService extends ActivityService {

    override readonly api = 'https://__tenant__/api/portal/contractor/activities';

    constructor() {
        super();
    }

    override share(request: ActivityShareRequest): void {
        throw new Error('Method not implemented.');
    }

}